import { useSelector } from "react-redux";

import { Box, Grid, Link, Typography } from "@mui/material";

import DeckGL from "@deck.gl/react";
import { GeoJsonLayer } from "@deck.gl/layers";
import { StaticMap } from "react-map-gl";
import dayjs from "dayjs";

import { iconConfig } from "../../../config/config.icons";

const SitesData = ({ subheaderStyle, useMobileLayout }) => {
  const mapState = useSelector((state) => state.map);

  const selectedRow = useSelector((state) => state.dataExplorer.selectedRow);
  const latitude = parseFloat(selectedRow.row.latitude);
  const longitude = parseFloat(selectedRow.row.longitude);

  const iconLayerParams = {
    pointType: "icon",
    getIconColor: [0, 100, 200, 255],
    getIcon: () => iconConfig["circle"],
    getIconSize: 16,
    iconSizeUnits: "pixels",
  };

  const sharedLayerParams = {
    id: "site-layer",
    data: [
      {
        type: "Feature",
        id: selectedRow.row.site_number,
        geometry: {
          type: "Point",
          coordinates: [longitude, latitude],
        },
      },
    ],
    extruded: true,
    filled: true,
    getElevation: 30,
    stroked: false,
    pickable: false,
  };

  return (
    <>
      <Grid
        item
        xs={12}
        md={useMobileLayout ? 12 : 8}
        sx={{ flexGrow: 1, overflowY: "auto" }}
      >
        <Box>
          {selectedRow.row.site_number && (
            <Box sx={{ display: "flex", gap: 1 }}>
              <Typography {...subheaderStyle}>
                Site number
                <Typography
                  sx={{
                    color: "primary.contrastText",
                  }}
                >
                  {selectedRow.row.site_number}
                </Typography>
              </Typography>
            </Box>
          )}
          {selectedRow.row.nwis_site_url && (
            <Box sx={{ display: "flex", gap: 1 }}>
              <Typography {...subheaderStyle}>
                Site Link:
                <Typography>
                  <Link
                    href={selectedRow.row.nwis_site_url}
                    sx={{
                      color: "#42a5f5",
                    }}
                    target="_blank" // opens link in new tab
                  >
                    {selectedRow.row.nwis_site_url}
                  </Link>
                </Typography>
              </Typography>
            </Box>
          )}
          {selectedRow.row.site_number && (
            <Box sx={{ display: "flex", gap: 1 }}>
              <Typography {...subheaderStyle}>
                Installation Date
                <Typography
                  sx={{
                    color: "primary.contrastText",
                  }}
                >
                  {dayjs(selectedRow.row.installation_date).format(
                    "MM/DD/YYYY"
                  )}
                </Typography>
              </Typography>
            </Box>
          )}
          {selectedRow.row.site_status && (
            <Box sx={{ display: "flex", gap: 1 }}>
              <Typography {...subheaderStyle}>
                Status
                <Typography
                  sx={{
                    color: "primary.contrastText",
                  }}
                >
                  {selectedRow.row.site_status?.name}
                </Typography>
              </Typography>
            </Box>
          )}
          {selectedRow.row.site_type && (
            <Box sx={{ display: "flex", gap: 1 }}>
              <Typography {...subheaderStyle}>
                Site Type
                <Typography
                  sx={{
                    color: "primary.contrastText",
                  }}
                >
                  {selectedRow.row.site_type?.name}
                </Typography>
              </Typography>
            </Box>
          )}
          {selectedRow.row.notes && (
            <Typography
              sx={{
                mt: 3,
                color: "primary.contrastText",
              }}
            >
              {selectedRow.row.notes}
            </Typography>
          )}
        </Box>
      </Grid>
      <Grid item xs={12} md={useMobileLayout ? 12 : 4} sx={{ mt: 3 }}>
        {/* render inset deck.gl map with site location */}
        {!useMobileLayout &&
          selectedRow.row.latitude &&
          selectedRow.row.longitude && (
            <Box sx={{ height: "300px", position: "relative" }}>
              <DeckGL
                initialViewState={{
                  longitude,
                  latitude,
                  zoom: 12,
                }}
                style={{
                  width: "100%",
                  height: "100%",
                  overflow: "hidden",
                }}
              >
                <GeoJsonLayer
                  id="icon-layer"
                  {...sharedLayerParams}
                  {...iconLayerParams}
                />
                <StaticMap
                  // key required to prevent basemap rerender
                  //  see https://github.com/visgl/deck.gl/issues/4419
                  key="basemap"
                  mapStyle={mapState.basemap.src}
                  mapboxApiAccessToken={
                    process.env.REACT_APP_MAPBOX_ACCESS_TOKEN
                  }
                />
              </DeckGL>
            </Box>
          )}
      </Grid>
    </>
  );
};

export default SitesData;
